// Product page: when a buckle finish is picked, that finish's photo becomes the large one
// and the other photos drop to small thumbnails. Variant -> photo map is the JSON in the gallery.
const gallery = document.querySelector('[data-product-gallery]')
const mapEl = document.querySelector('[data-variant-media]')

if (gallery && mapEl) {
  let variantMedia = {}
  try {
    variantMedia = JSON.parse(mapEl.textContent)
  } catch {
    variantMedia = {}
  }

  document.addEventListener('change', (event) => {
    const input = event.target
    if (!(input instanceof Element) || !input.closest('s-variant-picker')) return
    const variantId = input.dataset.variantId || input.selectedOptions?.[0]?.dataset?.variantId
    const mediaId = variantId && variantMedia[variantId]
    if (!mediaId) return
    gallery.querySelectorAll('[data-gallery-item]').forEach((item) => {
      const lead = item.dataset.mediaId === mediaId
      item.classList.toggle('order-first', lead)
      item.classList.toggle('md:col-span-4', lead)
    })
    // On mobile the photos scroll sideways: bring the chosen one into view.
    gallery.querySelector(`[data-media-id="${mediaId}"]`)?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' })
  })
}
